import { createSelector } from '@ngrx/store';
import { State } from '../state';
import { LocalFiltersState } from './local-filters.state';
import { getFiltersModuleState } from '../feature-selector';
import { LocalFilters } from '~app/modules/filters/models';

export const getLocalFiltersState = createSelector(getFiltersModuleState,
  (state: State) => state && state.localFilters
);
export const getLocalFilters = createSelector(getLocalFiltersState,
  (state: LocalFiltersState) => state && state.payload
);

// Local Filters Category selectors
export const getLocalFilterCategories = createSelector(getLocalFilters,
  (localFilters: LocalFilters) => (localFilters && localFilters.categories) || []
);

// Local Filters Attributes selectors
export const getLocalFilterAttributes = createSelector(getLocalFilters,
  (localFilters: LocalFilters) => (localFilters && localFilters.attributes) || []
);
